import { render, staticRenderFns } from "./ImageCardFile.vue?vue&type=template&id=6cdcbf17&"
import script from "./ImageCardFile.vue?vue&type=script&lang=js&"
export * from "./ImageCardFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports